import * as React from 'react';
import {
    DoubleBounce1,
    DoubleBounce2,
    Spinner
} from './styles';

export interface LoeaderProps {
    margin?: string;
}

export const Loader = (props: LoeaderProps) => {
    return (
        <Spinner margin={props.margin}>
            <DoubleBounce1 />
            <DoubleBounce2 />
        </Spinner>
    );
};

export default Loader;
